import posthog from 'posthog-js'

import { SessionUser } from '@mangovoice/types'

const PEAK_DENTAL = 8653
const ABC_EAST = 55
const XYZ_EAST = 4293
const PLUS_ONE_COMPANY = 3235

const pbxLabelMap: Record<number, string> = {
  [PEAK_DENTAL]: 'peak',
  [ABC_EAST]: 'abc-east',
  [XYZ_EAST]: 'xyz-east',
  [PLUS_ONE_COMPANY]: 'plus-one-company',
}

const pbxWhiteList = [PEAK_DENTAL]
const userWhiteList = [
  'plus1test10',
  'plus1test11',
  'plus1test12',
  'plus1test13',
  'plus1test14',
  'plus1test15',
  'plus1test16',
  'plus1test17',
  'plus1test18',
  'plus1test19',
  'plus1test20',
  'plus1test21',
  'plus1test22',
  'plus1test23',
  'plus1test24',
]

export const initializePosthog = (PBX_ID: number, user?: SessionUser) => {
  if (!user) {
    return
  }

  const whiteListedPbx = pbxWhiteList.includes(PBX_ID)
  const whiteListedUser = userWhiteList.includes(user?.username ?? '')

  if (!(whiteListedPbx || whiteListedUser)) {
    return
  }

  posthog.init('phc_eHw0OL0P86iMhGe8inNIduB3Um0uqvRKRUGoWA3wZDH', {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
  })

  posthog.identify(user.id.toString(), {
    name: user.first_name + ' ' + user.last_name,
    email: user.email,
    customer: pbxLabelMap?.[PBX_ID] ?? '',
  })
}
